import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterlistType',
    standalone: false
})
export class FilterlistTypePipe implements PipeTransform {

    transform(value: any): any {
      if(value === 1) {
        return 'Kundnummer';
      }
      if(value === 2) {
          return 'Avtal';
      }
      if(value === 3) {
          return 'Kostnadsställe';
      }
    }
  
  }